import { gql } from '@apollo/client';

export const GET_SUGGESTION_OPEN_AI_QUERY = gql`
  query GetSuggestionOpenAi($prompt: String!) {
    getSuggestionOpenAi(prompt: $prompt)
  }
`;
